// SVG element creation. Attributes, not properties, because SVG DOM
// properties are read-only animated values.

const SVG_NS = 'http://www.w3.org/2000/svg';

export type SvgAttributes = Record<string, string | number>;

export const svg = <K extends keyof SVGElementTagNameMap>(
  tag: K,
  attributes?: SvgAttributes,
  children?: readonly (SVGElement | string)[],
): SVGElementTagNameMap[K] => {
  const node = document.createElementNS(SVG_NS, tag);
  if (attributes) setAttributes(node, attributes);
  if (children) {
    for (const child of children) {
      if (typeof child === 'string') node.appendChild(document.createTextNode(child));
      else node.appendChild(child);
    }
  }
  return node;
};

export const setAttributes = (node: Element, attributes: SvgAttributes): void => {
  for (const [key, value] of Object.entries(attributes)) {
    node.setAttribute(key, String(value));
  }
};
